export default function stringToObjRef (rootObj, string, value) {
    if(!rootObj) return;
    if (typeof string == 'string') return stringToObjRef(rootObj,string.split('.'), value);
    else if (string.length === 1 && value !== undefined) return rootObj[string[0]] = value; // set value
    else if (string.length === 0) return rootObj; // get value
    else return stringToObjRef(rootObj[string[0]],string.slice(1), value);
}